/** Shared surfaces matching `/home` feed (ActualHomePage). */

export function feedSurfaceClass(isDark) {
  return isDark
    ? "border-white/10 bg-slate-900/50 backdrop-blur-sm"
    : "border-slate-200/90 bg-white shadow-sm";
}

export function feedDividerClass(isDark) {
  return "border-separator-default";
}

export function feedMutedTextClass(isDark) {
  return "text-label-secondary";
}

export function feedInputClass(isDark) {
  return isDark
    ? "border-transparent bg-white/[0.04] text-slate-100 placeholder-slate-500 focus:border-accent-default focus:bg-white/[0.06] focus:ring-1 focus:ring-accent-default"
    : "border-transparent bg-slate-100/80 text-slate-900 placeholder-slate-400 focus:border-accent-default focus:bg-white focus:ring-1 focus:ring-accent-default";
}

/** Opaque panel for discover card grids (readable on transparent canvases). */
export function discoverGridShellClass(isDark) {
  return isDark
    ? "border-white/10 bg-slate-900/95"
    : "border-slate-200/90 bg-white shadow-sm";
}

/** Discover grid cards — solid panels so they stay visible on /home and mint-space discover. */
export function discoverCardClass(isDark, isSelected = false) {
  const base = `h-full overflow-hidden rounded-radius-md border ${discoverGridShellClass(isDark)} transition duration-200`;
  if (isSelected) {
    return `${base} ring-2 ring-accent-default shadow-lg`;
  }
  return `${base}`;
}

export function discoverGridClass() {
  return "cc-campaign-grid grid grid-cols-1 items-stretch sm:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3";
}

/** Mint space window outer shell when Discover is active — show app canvas through. */
export function mintSpaceDiscoverCanvasClass() {
  return "border-transparent bg-transparent";
}

/** Mint space top nav on Discover — no billing bar fill. */
export function mintSpaceDiscoverTopNavClass(isDark) {
  return "relative border-b border-separator-default bg-transparent";
}
